import gql from 'graphql-tag';

export const DEAL_CALL_ACTIVITY_FRAGMENT = gql`
  fragment DealCallActivityFields on DealCallActivityViewModel {
    id
    type
    topic
    parentId
    callStatus
    description
    callDirection
    createdDateTime
    updatedDateTime
    participants {
      id
      fullName
      participationType
    }
  }
`;
